import { render, staticRenderFns } from "./DataScreenCategoryList.vue?vue&type=template&id=6e2c1792"
import script from "./DataScreenCategoryList.vue?vue&type=script&lang=js"
export * from "./DataScreenCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2c1792')) {
      api.createRecord('6e2c1792', component.options)
    } else {
      api.reload('6e2c1792', component.options)
    }
    module.hot.accept("./DataScreenCategoryList.vue?vue&type=template&id=6e2c1792", function () {
      api.rerender('6e2c1792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataScreenCategoryList.vue"
export default component.exports